import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";

import { AuthenticationService } from "../../services/auth.service";
import { AuthfakeauthenticationService } from "../../services/authfake.service";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private authfackservice: AuthfakeauthenticationService,
    public router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (sessionStorage.getItem("auth-token")) {
      // add authorization header with jwt token if available
      let currentUser = sessionStorage.getItem("auth-token");
      if (currentUser && currentUser) {
        request = request.clone({
          setHeaders: {
            Authorization: `Basic ${currentUser}`,
          },
        });
      }
    } else {
      // add authorization header with jwt token if available
      const currentUser = this.authfackservice.currentUserValue;
      if (currentUser && currentUser.base64EncodedAuthenticationKey) {
        request = request.clone({
          setHeaders: {
            Authorization: `Basic ${currentUser.base64EncodedAuthenticationKey}`,
          },
        });
      }
    }
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401) {
          this.router.navigate(["/authentication"]);
        }
        return throwError(error);
      })
    );
  }
}
